@use '../../scss/utility';

:host {
  display: none;
  border-block-start: utility.wb-pixel-to-rem(1px) solid var(--wb-grey-15);
  background-color: var(--wb-black);

  @include utility.breakpoint-from(mq5) {
    display: block;
  }
}

.inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: var(--wb-grid-width);
  margin-inline-start: auto;
  margin-inline-end: auto;
  position: relative;
}
